import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';
import RescheduleAdmisionModal from './RescheduleAdmisionModal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import ModalChangeAppointmentDate from './ModalChangeAppointmentDate';

const ListRequestRescheduleActions = ({ 
  data,
  setDataEvent,
  closeModalReschedule,
  CallbackCalendar,
  CallbackReschedule,
   
}) => {

  const [modalRescheduleAdmision, setModalRescheduleAdmision] = useState(false);

  useEffect(() => {
  }, [])

  return (<Fragment>
    {/*
    <Tooltip title="Ver Cita">
      <IconButton aria-label="unable" style={{ padding: 2 }}
        disabled={true}
        onClick={() => {
          setDataEvent(data.data.original);
        }}>
        <LaunchIcon style={{ color: '#000' }} />
      </IconButton>
    </Tooltip>*/}

    <Tooltip title="Reagendar Admisión">
      <IconButton aria-label="unable" style={{ padding: 2 }}
        onClick={() => {
          setModalRescheduleAdmision(true);
        }}>
        <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#000' }} />
      </IconButton>
    </Tooltip>

    {
    <RescheduleAdmisionModal
      openModalRescheduleAdmision={modalRescheduleAdmision}
      returnAgenda={() => {
        setModalRescheduleAdmision(false);
        closeModalReschedule();
      }}
      closeModalRescheduleAdmision={() => {
        setModalRescheduleAdmision(false);
        closeModalReschedule();
        CallbackReschedule();
        CallbackCalendar();
      }}
      date={data.data.original.start}
      services={data.data.original.servicios}
      id_admision={data.data.original.id_admision}
      id_historia={data.data.original.id_historia}
    />}

  </Fragment>)
}

export default ListRequestRescheduleActions;